const dateFmt = new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit" });
const dateLongFmt = new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
const timeFmt = new Intl.DateTimeFormat("it-IT", { hour: "2-digit", minute: "2-digit" });
const dayFmt = new Intl.DateTimeFormat("it-IT", { weekday: "short", day: "2-digit", month: "short" });
const currencyFmt = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

const toDate = (v) => (v ? new Date(v) : null);

export const fmtDate = (v) => (v ? dateFmt.format(toDate(v)) : "—");
export const fmtDateLong = (v) => (v ? dateLongFmt.format(toDate(v)) : "—");
export const fmtTime = (v) => (v ? timeFmt.format(toDate(v)) : "");
export const fmtDay = (v) => (v ? dayFmt.format(toDate(v)) : "—");
export const fmtDateTime = (v) => (v ? `${dateLongFmt.format(toDate(v))} ${timeFmt.format(toDate(v))}` : "—");
export const fmtCurrency = (v) => currencyFmt.format(v || 0);

export const isToday = (v) => {
  if (!v) return false;
  const d = toDate(v);
  const n = new Date();
  return d.toDateString() === n.toDateString();
};

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 13) return "Buongiorno";
  if (h < 18) return "Buon pomeriggio";
  return "Buonasera";
};

export const initials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
